import React from 'react'
import Content from '../Content'
import Style from './index.module.scss'

export default ({ content, contentComponent }) => {
  const PostContent = contentComponent || Content
  return <PostContent className={Style.markdownBody} content={content} />
}
